window.addEventListener("scroll", function () {
    var height = window.pageYOffset;
    var header = document.querySelector('.header');

    if (height > 30) {
        header.classList.add('header--sticky');
    } else {
        header.classList.remove('header--sticky');
    }
});